module.exports = __webpack_public_path__ + "assets/images/vault.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/vault.png
// module id = 261
// module chunks = 1